import { useQuery } from '@tanstack/react-query';
import { rolesApi } from '../api/roles';
import { RoleDefinitionDto } from '../types';

export function useRoles() {
  return useQuery<RoleDefinitionDto[], Error>({
    queryKey: ['roles'],
    queryFn: () => rolesApi.list(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
